var pl = {
	"neptune.Button.loadingAriaLabel": "ładowanie",
	"neptune.Chips.ariaLabel": "Wyczyść {choice}",
	"neptune.ClearButton.ariaLabel": "Wyczyść",
	"neptune.CloseButton.ariaLabel": "Zamknij",
	"neptune.DateInput.day.label": "Dzień",
	"neptune.DateInput.day.placeholder": "DD",
	"neptune.DateInput.month.label": "Miesiąc",
	"neptune.DateInput.year.label": "Rok",
	"neptune.DateInput.year.placeholder": "RRRR",
	"neptune.DateLookup.day": "dzień",
	"neptune.DateLookup.goTo20YearView": "Przejdź do widoku 20-letniego",
	"neptune.DateLookup.month": "miesiąc",
	"neptune.DateLookup.next": "następny",
	"neptune.DateLookup.previous": "poprzedni",
	"neptune.DateLookup.selected": "wybrano",
	"neptune.DateLookup.twentyYears": "20 lat",
	"neptune.DateLookup.year": "rok",
	"neptune.FlowNavigation.back": "wróć do poprzedniego kroku",
	"neptune.Info.ariaLabel": "Więcej informacji",
	"neptune.Label.optional": "(opcjonalne)",
	"neptune.Link.opensInNewTab": "(otworzy się w nowej zakładce)",
	"neptune.MoneyInput.Select.placeholder": "Wybierz opcję...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Wybierz walutę",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Wybierz opcję...",
	"neptune.Select.searchPlaceholder": "Wyszukaj...",
	"neptune.SelectInput.noResultsFound": "Nie znaleziono wyników",
	"neptune.SelectOption.action.label": "Wybierz",
	"neptune.SelectOption.selected.action.label": "Zmień wybraną opcję",
	"neptune.StatusIcon.iconLabel.error": "Błąd:",
	"neptune.StatusIcon.iconLabel.information": "Informacje:",
	"neptune.StatusIcon.iconLabel.pending": "W toku:",
	"neptune.StatusIcon.iconLabel.success": "Gotowe:",
	"neptune.StatusIcon.iconLabel.warning": "Ostrzeżenie:",
	"neptune.Summary.statusDone": "Czynność wykonana",
	"neptune.Summary.statusNotDone": "Czynność do wykonania",
	"neptune.Summary.statusPending": "Czynność oczekująca",
	"neptune.Table.actionHeader": "Działanie",
	"neptune.Table.emptyData": "Nie znaleziono wyników",
	"neptune.Table.loaded": "Wczytano dane tabeli",
	"neptune.Table.loading": "Wczytywanie danych tabeli",
	"neptune.Table.refreshPage": "Odśwież stronę",
	"neptune.Upload.csButtonText": "Prześlij kolejny plik?",
	"neptune.Upload.csFailureText": "Przesyłanie nie powiodło się. Proszę spróbować ponownie",
	"neptune.Upload.csSuccessText": "Przesyłanie zakończone!",
	"neptune.Upload.csTooLargeMessage": "Prosimy przesłać plik mniejszy niż {maxSize} MB",
	"neptune.Upload.csWrongTypeMessage": "Nieobsługiwany typ pliku. Spróbuj ponownie z innym plikiem",
	"neptune.Upload.psButtonText": "Anuluj",
	"neptune.Upload.psProcessingText": "Przesyłanie...",
	"neptune.Upload.retry": "Spróbuj ponownie",
	"neptune.Upload.usButtonText": "Lub wybierz plik",
	"neptune.Upload.usDropMessage": "Upuść plik, aby rozpocząć przesyłanie",
	"neptune.Upload.usPlaceholder": "Przeciągnij i upuść plik nie większy niż {maxSize} MB",
	"neptune.UploadButton.allFileTypes": "Wszystkie typy plików",
	"neptune.UploadButton.dropFiles": "Upuść plik, żeby rozpocząć przesyłanie",
	"neptune.UploadButton.instructions": "{fileTypes}, mniejsze niż {size}MB",
	"neptune.UploadButton.maximumFiles": "Maksymalna ilość plików: {maxFiles}.",
	"neptune.UploadButton.uploadFile": "Prześlij plik",
	"neptune.UploadButton.uploadFiles": "Prześlij pliki",
	"neptune.UploadInput.deleteModalBody": "Usunięcie tego pliku oznacza usunięcie go z naszego systemu.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Anuluj",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Usuń",
	"neptune.UploadInput.deleteModalTitle": "Czy na pewno chcesz usunąć ten plik?",
	"neptune.UploadInput.fileIsTooLarge": "Plik jest za duży",
	"neptune.UploadInput.fileTypeNotSupported": "Nieobsługiwany typ pliku",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Przepraszamy, przesłanie nie powiodło się, ponieważ możemy zaakceptować wyłącznie {maxFilesAllowed} pliki/plików naraz.",
	"neptune.UploadItem.deleting": "Usuwanie...",
	"neptune.UploadItem.removeFile": "Usuń plik {filename}",
	"neptune.UploadItem.uploaded": "Przesłano",
	"neptune.UploadItem.uploadedFile": "Przesłany plik",
	"neptune.UploadItem.uploading": "Przesyłanie...",
	"neptune.UploadItem.uploadingFailed": "Przesyłanie nie powiodło się"
};

export { pl as default };
//# sourceMappingURL=pl.json.mjs.map
